import { Mail, MessageCircle, MessageSquare, Phone } from 'lucide-react';
import { SocialLogo } from '../ui';

/** The outreach channels' marks — shared by the map's outreach column and the Channels-out settings list:
 *  brand logos where the app ships them, lucide glyphs for the rest. Draws in `currentColor` at `size`
 *  (default 24 — the map column; the Channels-out plate passes 16 to match its 16px brand logos). */
export function OutreachChannelGlyph({ slug, size = 24 }: { slug: string; size?: number }) {
  switch (slug) {
    case 'instagram':
      return <SocialLogo network="INSTAGRAM" size={size} />;
    case 'x':
      return <SocialLogo network="X" size={size} />;
    case 'messenger':
      return <SocialLogo network="FACEBOOK" size={size} />;
    case 'email':
      return <Mail size={size} aria-hidden />;
    case 'phone':
      return <Phone size={size} aria-hidden />;
    case 'sms':
    case 'imessage':
      return <MessageSquare size={size} aria-hidden />;
    case 'whatsapp':
    default:
      return <MessageCircle size={size} aria-hidden />;
  }
}
